// extracted by mini-css-extract-plugin
module.exports = {"logoTitle":"header_logo_title-module__logoTitle--A4xLc"};